import { Component, OnInit, Input } from '@angular/core';
import { HistoryModel } from '../history/history.model';
import { HistoryService } from '../history/history.service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-table-detail-history',
  templateUrl: './table-detail-history.component.html',
  styleUrls: ['./table-detail-history.component.scss']
})
export class TableDetailHistoryComponent implements OnInit {

  @Input() entityName: string;
  @Input() entityId: number;

  public data: HistoryModel[] = [];

  displayedColumns: string[] = ['timestamp', 'message', 'change', 'user'];

  constructor(private historyService: HistoryService) {
  }

  ngOnInit(): void {
    this.historyService.get(this.entityName, this.entityId).subscribe(
      (data) => {
        this.data = plainToClass(HistoryModel, data);
      },
      (error) => {},
      () => {}
    );
  }

}
